module.exports = __webpack_public_path__ + "graphics/icon-roblox-studio.ckh.ae24be5da10ece496bd09f1474e5e00a.svg";